import React from "react";
import { Modal } from "react-bootstrap";
import PreferencesPanel from "./PreferencesPanel";

// Thin wrapper around <PreferencesPanel>. The panel owns the form state and
// the save call; we just close the modal once it reports success.
// Header styling mirrors CreateTaskModal for consistency across the app.
export default function SettingsModal({ show, onHide }) {
  return (
    <Modal show={show} onHide={onHide} centered backdrop="static">
      <Modal.Header
        closeButton
        style={{ background: "#CFE2FF" }}
        className="rounded-0 text-primary d-flex align-items-center"
      >
        <Modal.Title as="h6" className="m-0">
          <i className="fa-light fa-gear me-2" />
          Settings
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <PreferencesPanel onSaved={onHide} />
      </Modal.Body>
    </Modal>
  );
}
